import { useState, useEffect, useCallback } from 'react';

export function useLocalStorage(key, initialValue, onSave) {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error(`Error reading localStorage key "${key}":`, error);
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      const valueToStore = JSON.stringify(storedValue);
      window.localStorage.setItem(key, valueToStore);
      
      // Fire the optional callback on successful save
      if (onSave && typeof onSave === 'function') {
        onSave();
      }
    } catch (error) {
      console.error(`Error writing localStorage key "${key}":`, error);
    }
  }, [key, storedValue, onSave]);

  return [storedValue, setStoredValue];
}